import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAutotaskComponent } from './simple-icons-autotask.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAutotaskComponent ],
    exports:      [ SimpleIconsAutotaskComponent ],
    bootstrap:    []
})
export class SimpleIconsAutotaskModule {}
